module.exports = __webpack_public_path__ + "media/images/loghi/placeholder-8d75ec6ce01eb05f539c381da6fe4c1d.png";